/* Kkumi product reviews — photo grid + lightbox.
   Extracted from sections/kkumi-product-reviews.liquid. */
(function() {
  function patchKlaviyo(w) {
    var sec = document.querySelector('[data-verified-bg]');
    var verifiedBg = sec ? sec.dataset.verifiedBg : '#C8E8DD';
    var verifiedText = sec ? sec.dataset.verifiedText : '#1F5F4F';
    var starColor = sec ? sec.dataset.starColor : '#E0277F';

    w.querySelectorAll('.kl_reviews__star--fill').forEach(function(stop) {
      stop.style.setProperty('stop-color', starColor, 'important');
    });

    w.querySelectorAll('.kl_reviews__review__verified').forEach(function(el) {
      el.style.setProperty('background', verifiedBg, 'important');
      el.style.setProperty('color', verifiedText, 'important');
    });

    w.querySelectorAll('.kl_reviews__button').forEach(function(btn) {
      btn.classList.remove('kl_reviews__button');
      btn.classList.add('button');
      if (btn.textContent.trim().toLowerCase().indexOf('write') !== -1) {
        btn.classList.add('button--primary');
      } else {
        btn.classList.add('button--secondary');
      }
      btn.style.setProperty('font-weight', 'normal', 'important');
    });

    w.querySelectorAll('.kl_reviews__review__title').forEach(function(el) {
      el.style.setProperty('font-weight', 'normal', 'important');
    });
    w.querySelectorAll('.kl_reviews__list__tab').forEach(function(el) {
      el.style.setProperty('font-weight', 'normal', 'important');
    });

    w.querySelectorAll('.kl_reviews__input_with_search_icon').forEach(function(el) {
      el.style.setProperty('cursor', 'text', 'important');
    });

    var isMobile = window.innerWidth < 750;

    w.querySelectorAll('.kl_reviews__list_container').forEach(function(el) {
      el.style.setProperty('display', 'contents', 'important');
    });
    w.querySelectorAll('.kl_reviews__list_container > [role="status"]').forEach(function(el) {
      if (isMobile) {
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('flex-wrap', 'nowrap', 'important');
        el.style.setProperty('overflow-x', 'auto', 'important');
        el.style.setProperty('-webkit-overflow-scrolling', 'touch');
        el.style.setProperty('scroll-snap-type', 'x mandatory', 'important');
        el.style.setProperty('gap', '16px', 'important');
        el.style.setProperty('padding-bottom', '8px');
        el.style.setProperty('scrollbar-width', 'none');
      } else {
        el.style.setProperty('display', 'grid', 'important');
        el.style.setProperty('grid-template-columns', 'repeat(3, 1fr)', 'important');
        el.style.setProperty('gap', '22px', 'important');
      }
    });

    w.querySelectorAll('.kl_reviews__review_item').forEach(function(el) {
      el.style.setProperty('margin-bottom', '0', 'important');
      if (isMobile) {
        el.style.setProperty('min-width', '85vw', 'important');
        el.style.setProperty('max-width', '85vw', 'important');
        el.style.setProperty('flex-shrink', '0', 'important');
        el.style.setProperty('scroll-snap-align', 'start', 'important');
      }
    });

    var grid = document.getElementById('kk-review-photos');
    if (grid) {
      var imgs = w.querySelectorAll('.kl_reviews__review__image_row img');
      if (imgs.length) {
        grid.innerHTML = '';
        var shown = 0;
        imgs.forEach(function(img) {
          if (shown >= 12) return;
          var div = document.createElement('div');
          div.className = 'kk-pdp-reviews__photo-thumb';
          var clone = document.createElement('img');
          clone.src = img.src;
          clone.alt = '';
          clone.loading = 'lazy';
          div.appendChild(clone);
          grid.appendChild(div);
          shown++;
        });
        if (imgs.length > 12) {
          var more = document.createElement('div');
          more.className = 'kk-pdp-reviews__photo-thumb kk-pdp-reviews__photo-more';
          more.innerHTML = '+' + (imgs.length - 12) + '<small>PHOTOS</small>';
          grid.appendChild(more);
        }
      }
    }
  }

  var patching = false;
  function tryPatch() {
    if (patching) return;
    var w = document.getElementById('klaviyo-product-reviews-wrapper');
    if (!w || !w.querySelector('.kl_reviews__review_item, .kl_reviews__list__tab')) return;
    patching = true;
    patchKlaviyo(w);
    patching = false;
  }

  var poll = setInterval(function() {
    var w = document.getElementById('klaviyo-product-reviews-wrapper');
    if (w && w.querySelector('.kl_reviews__review_item, .kl_reviews__list__tab')) {
      clearInterval(poll);
      patchKlaviyo(w);
    }
  }, 500);

  setTimeout(function() { clearInterval(poll); }, 15000);
})();
